import * as z from "zod";

// Basic table booking toggle schema
export const tableBookingToggleSchema = z.object({
  isEnabled: z.boolean(),
  type: z.enum(["classic", "supreme"]),
});

// Restaurant settings schema
export const tableBookingRestaurantSettingsSchema = z.object({
  deposit: z.array(z.object({
    priceConfiguration: z.array(z.object({
      minCover: z.coerce.number().min(1, "Min cover must be at least 1"),
      maxCover: z.coerce.number().min(1, "Max cover must be at least 1"),
      price: z.coerce.number().min(0, "Price cannot be negative").max(10000, "Price is too high"),
    })),
  })),
  restaurantEmails: z.array(z.string().email("Invalid email address")),
  restaurantPhones: z.array(z.string().min(1, "Phone number is required")),
  maxCoverPerBooking: z.coerce.number().min(1, "Max cover per booking must be at least 1"),
  standardSeatingTimeMinutes: z.coerce.number().min(1, "Standard seating time must be at least 1 minute"),
  bookingIntervalMinutes: z.coerce.number().min(1, "Booking interval must be at least 1 minute"),
  termsLink: z.string().optional(),
  bookingAvailability: z.array(z.object({
    dayOfWeek: z.string().min(1, "Day of week is required"),
    openingTime: z.string().min(1, "Opening time is required"),
    closingTime: z.string().min(1, "Closing time is required"),
    totalCovers: z.coerce.number().optional(),
    availableCovers: z.coerce.number().optional(),
  })),
});

// Combined schema for both basic and restaurant settings
export const combinedTableBookingSchema = z.object({
  // Basic settings - Always required
  isEnabled: z.boolean(),
  type: z.enum(["classic", "supreme"]),
  
  // Restaurant settings - All optional, no validation when disabled
  deposit: z.array(z.object({
    priceConfiguration: z.array(z.object({
      minCover: z.coerce.number().optional(),
      maxCover: z.coerce.number().optional(),
      price: z.coerce.number().optional(),
    })).optional(),
  })).optional(),
  restaurantEmails: z.array(z.string()).optional(),
  restaurantPhones: z.array(z.string()).optional(),
  maxCoverPerBooking: z.coerce.number().optional(),
  standardSeatingTimeMinutes: z.coerce.number().optional(),
  bookingIntervalMinutes: z.coerce.number().optional(),
  termsLink: z.string().optional(),
  bookingAvailability: z.array(z.object({
    dayOfWeek: z.string().optional(),
    openingTime: z.string().optional(),
    closingTime: z.string().optional(),
    totalCovers: z.coerce.number().optional(),
    availableCovers: z.coerce.number().optional(),
  })).optional(),
}).passthrough(); // Allow additional fields to pass through without validation
